import React, { Component } from "react";
import ReactDOM from "react-dom";
import "../../../style/customalertmessage.css";
import moment from "moment";
import Scheduler, { SchedulerData, ViewTypes } from "react-big-scheduler";
import { Redirect } from "react-router-dom";
import withDragDropContext from "../../../withDnDContext";
import { Overlay, Tooltip } from "react-bootstrap";
import { faWindowClose } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import "react-big-scheduler/lib/css/style.css";
import { Button } from "reactstrap";
import { connect } from "react-redux";
import {ExpandedTaskView} from "../../../components/tasks/index";
const taskColor = ["#FA9E95", "#6a7d15", "#a6120d"];

const TooltipContent = ({ onClose, event }) => (
  <>
    <FontAwesomeIcon icon={faWindowClose} className="pull-right" style={{ cursor: "pointer" }} onClick={onClose} />
    <div>Project - {event.projectName}</div>
    <div>{event.title}</div>
    <div>Description - {event.description}</div>
    <div>Hours Billable - {event.hoursbillable}</div>
    <div>Hours Spent - {event.hoursspent}</div>
    <div>Status - {event.status}</div>
  </>
);

class Basic extends Component {
  constructor(props) {
    super(props);
    this.state = {
      calendarShedularData: new SchedulerData(new Date(), ViewTypes.Week, false, false, {
        schedulerWidth: "80%",
      }),
      calendarShedularDataExpand: new SchedulerData(new Date(), ViewTypes.Week, false, false, {
        schedulerWidth: "80%",
      }),
      calendarData: {},
      calendarDataExp: {},
      expandedView: false,
    };

    this.state.calendarShedularData.config.eventItemLineHeight = 30;
    this.state.calendarShedularData.config.eventItemHeight = 80;
    this.state.calendarShedularData.config.creatable = false;
    this.state.calendarShedularData.config.schedulerMaxHeight = 0;
  }

  componentDidMount() {
    const { selectedTask } = this.props;
    this.dataPopulationReactScheduler(selectedTask);
  }

  componentDidUpdate(prevProps) {
    const { fullTaskArr } = this.props.fullTaskArr;
    if (prevProps.fullTaskArr.fullTaskArr.length !== fullTaskArr.length) {
      this.dataPopulationReactScheduler(fullTaskArr);
    }
  }

  dataPopulationReactScheduler = (fullTaskArr) => {
    const resources = this.getProjectNames(fullTaskArr);
    const events = this.getEvents(fullTaskArr);

    const resourcesExp = this.getTaskNamesAsResources(fullTaskArr);
    const eventsExp = this.getEventExp(fullTaskArr);

    const { calendarShedularData, calendarShedularDataExpand } = this.state;
    calendarShedularData.setResources(resources);
    calendarShedularData.setEvents(events);

    calendarShedularDataExpand.setResources(resourcesExp);
    calendarShedularDataExpand.setEvents(eventsExp);
    this.setState({
      calendarShedularData,
      calendarShedularDataExpand,
      calendarData: { resources, events },
      calendarDataExp: { resourcesExp, eventsExp },
    });
  };

  getProjectNames = (fullTaskArr) => {
    return Array.from(new Set(fullTaskArr.map(t => t.projectID)))
      .filter(id => id !== 0)
      .map(id => {
        const task = fullTaskArr.find(t => t.projectID === id);
        return { id, name: task.projectName };
      });
  };

  getTaskNamesAsResources = (fullTaskArr) => {
    const uniqueTasks = Array.from(new Set(fullTaskArr
      .filter(el => el.startTime !== null)
      .map(el => el.issueTitle)));

    return uniqueTasks.map((taskName, index) => ({
      id: taskName,
      name: taskName,
    }));
  };

getEvents = (fullTaskArr) => {
  return fullTaskArr
    .filter(el => el.startTime !== null ) // ✅ exclude leaveStatus=true
    .map(el => ({
      id: el.employeeTimeSheetId,
      start: el.startTime,
      end: el.endTime,
      resourceId: el.projectID,
      title: el.issueTitle,
      description: el.description,
      hoursspent: el.hoursSpent,
      absentDate:el.absentDate,
      hoursbillable: el.hoursBillable,
      status:
        el.leaveStatus == true ? (el.timeSheetStatus === 1
              ? "Pending"
              : el.timeSheetStatus === 2
              ? "Approved"
              : "Rejected") : ( el.leaveStatusId === 1
          ? "Approved"
          : el.leaveStatusId === 0
          ? "Rejected"
          : "Pending"),
      bgColor: taskColor[Math.floor(Math.random() * taskColor.length)],
    }));
};
 getEventExp = (fullTaskArr) => {
  const events = [];
  const grouped = {};

  fullTaskArr
    .filter(el => el.startTime !== null) // ✅ exclude leaveStatus=true
    .forEach(el => {
      const taskName = el.issueTitle;
      const day = moment(el.startTime).format("MM/DD/YYYY HH:mm:ss");
      const key = `${taskName}_${day}`;

      if (!grouped[key]) {
        grouped[key] = {
          id: taskName,
          resourceId: taskName,
          start: day,
          end: day,
          title: el.hoursSpent,
          hoursspent: 0,
          hoursbillable: 0,
          description: el.description,
          projectName: el.projectName,
          absentDate:el.absentDate,
          isLeave:el.leaveStatus,
          status:
            el.leaveStatus == true ? (el.timeSheetStatus === 1
              ? "Pending"
              : el.timeSheetStatus === 2
              ? "Approved"
              : "Rejected") : ( el.leaveStatusId === 1
          ? "Approved"
          : el.leaveStatusId === 0
          ? "Rejected"
          : "Pending"),
          bgColor: taskColor[Math.floor(Math.random() * taskColor.length)],
        };
      }

      grouped[key].hoursspent += parseFloat(el.hoursSpent || 0);
      grouped[key].hoursbillable += parseFloat(el.hoursBillable || 0);
    });

    for (const key in grouped) {
      const item = grouped[key];
      events.push({
        ...item,
        title: `${item.hoursspent}`,
        start: moment(item.start).format("MM/DD/YYYY HH:mm:ss"),
        end: moment(item.end).format("MM/DD/YYYY HH:mm:ss"),
        hoursspent: parseFloat(item.hoursspent),
        hoursbillable:parseFloat(item.hoursbillable),
        absentDate:moment(item.absentDate).format("MM/DD/YYYY HH:mm:ss"),
      });
    }

  return events;
};

  // eventItemTemplateResolver = (schedulerData, event, bgColor, isStart, isEnd, mustAddCssClass, mustBeHeight) => (
  //   <div
  //     key={event.id}
  //     className={mustAddCssClass}
  //     style={{
  //       borderLeft: isStart ? '4px solid rgba(0,139,236,1)' : 'none',
  //       backgroundColor: bgColor,
  //       height: '44px',
  //       padding: '4px',
  //       overflow: 'hidden',
  //       color: 'white',
  //       fontSize: '12px',
  //       display: 'flex',
  //       flexDirection: 'column',
  //       justifyContent: 'center',
  //     }}
  //   >
  //     <strong>{event.title}</strong>
  //     <div style={{ fontSize: '11px' }}>
  //       {event.hoursspent && `Spent: ${event.hoursspent}h`}<br />
  //       {event.hoursbillable && `Billable: ${event.hoursbillable}h`}
  //     </div>
  //   </div>
  // );
//  eventItemTemplateResolverExp = (schedulerData, event, bgColor, isStart, isEnd, mustAddCssClass, mustBeHeight) => (
//     <div
//       key={event.id}
//       className={mustAddCssClass}
//       style={{
//         borderLeft: isStart ? '4px solid rgba(0,139,236,1)' : 'none',
//         backgroundColor: bgColor,
//         height: '44px',
//         padding: '4px',
//         overflow: 'hidden',
//         color: 'white',
//         fontSize: '12px',
//         display: 'flex',
//         flexDirection: 'column',
//         justifyContent: 'center',
//       }}
//     >
//       <strong>{event.title}</strong>
     
//     </div>
//   );
//   prevClick = (schedulerData) => {
//   schedulerData.prev();

//   const { expandedView, calendarData, calendarDataExp } = this.state;
//   const events = expandedView ? calendarDataExp.eventsExp : calendarData.events;

//   schedulerData.setEvents(events);

//   if (expandedView) {
//     this.setState({ calendarShedularDataExpand: schedulerData });
//   } else {
//     this.setState({ calendarShedularData: schedulerData });
//   }
// };

//  nextClick = (schedulerData) => {
//   schedulerData.next();

//   const { expandedView, calendarData, calendarDataExp } = this.state;
//   const events = expandedView ? calendarDataExp.eventsExp : calendarData.events;

//   schedulerData.setEvents(events);

//   if (expandedView) {
//     this.setState({ calendarShedularDataExpand: schedulerData });
//   } else {
//     this.setState({ calendarShedularData: schedulerData });
//   }
// };

// onViewChange = (schedulerData, view) => {
//   schedulerData.setViewType(view.viewType, view.showAgenda, view.isEventPerspective);

//   const { expandedView, calendarData, calendarDataExp } = this.state;
//   const events = expandedView ? calendarDataExp.eventsExp : calendarData.events;

//   schedulerData.setEvents(events);

//   if (expandedView) {
//     this.setState({ calendarShedularDataExpand: schedulerData });
//   } else {
//     this.setState({ calendarShedularData: schedulerData });
//   }
// };


//  onSelectDate = (schedulerData, date) => {
//   schedulerData.setDate(date);

//   const { expandedView, calendarData, calendarDataExp } = this.state;
//   const events = expandedView ? calendarDataExp.eventsExp : calendarData.events;

//   schedulerData.setEvents(events);

//   if (expandedView) {
//     this.setState({ calendarShedularDataExpand: schedulerData });
//   } else {
//     this.setState({ calendarShedularData: schedulerData });
//   }
// };


  // eventClicked = (schedulerData, event) => {
  //   alert(
  //     `Title: ${event.title} \nDescription: ${event.description}\nHours Spent: ${event.hoursspent}\nBillable: ${event.hoursbillable}\nStatus: ${event.status}`
  //   );
  // };

  // toggleExpandFunc = (schedulerData, slotId) => {
  //   schedulerData.toggleExpandStatus(slotId);
  //   this.setState({ calendarShedularData: schedulerData });
  // };

  computeRowWiseTotals = (events, resources) => {
  const totals = {};

  resources.forEach(resource => {
    totals[resource.id] = 0;
  });

  events.forEach(event => {
    const hours = parseFloat(event.hoursspent || 0);
    if (totals[event.resourceId] !== undefined) {
      totals[event.resourceId] += hours;
    }
  });

  return totals;
};


  render() {
  const { handleToggleAllTaskCalendar,fromDate,toDate,recholidayCalendarArray } = this.props;
  const { calendarDataExp } = this.state;

  return (
    <div>
      <Button outline className="primary mt-2" onClick={handleToggleAllTaskCalendar}>
        <i className="fas fa-arrow-left"></i> Back
      </Button>

      <div className="mt-3">
        <ExpandedTaskView fromDate={fromDate} toDate={toDate} tasks={calendarDataExp.eventsExp || [] } recholidayCalendarArray={recholidayCalendarArray}/>
      </div>
    </div>
  );
}
}

const mapStateToProps = (state) => ({
  fullTaskArr: state.taskReducer,
});

export default connect(mapStateToProps)(withDragDropContext(Basic));
